import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
import { ApiFactory } from '../agwasuite-api-factory';
import type {
  DataTableDataResponseOfSearchResultRow,
  ExecuteSearchInput,
  ExecuteSearchResult,
  GetSearchMetaResult,
  ResolveSearchResult,
  SearchMetaDto,
  SearchResultRow,
} from '../agwa-api-model';

const BASE_PATH = 'api/search';

export class SearchApi extends AGWASuiteApiClientBase {
  async getMeta(tag: string): Promise<ApiResponse<SearchMetaDto>> {
    const result = await this.request<GetSearchMetaResult>(
      'GET',
      `${BASE_PATH}/meta?tag=${encodeURIComponent(tag)}`
    );
    if (!result.success) return result;
    return { success: true, data: result.data.meta, status: result.status };
  }

  async executeSearch(
    input: ExecuteSearchInput
  ): Promise<ApiResponse<DataTableDataResponseOfSearchResultRow>> {
    const result = await this.postExecute<
      ExecuteSearchInput,
      ExecuteSearchResult
    >(BASE_PATH, input);
    if (!result.success) return result;
    return { success: true, data: result.data.page, status: result.status };
  }

  async resolve(
    tag: string,
    id: string
  ): Promise<ApiResponse<SearchResultRow>> {
    const result = await this.request<ResolveSearchResult>(
      'GET',
      `${BASE_PATH}/resolve/${encodeURIComponent(tag)}?value=${encodeURIComponent(id)}`
    );
    if (!result.success) return result;
    return { success: true, data: result.data.row, status: result.status };
  }
}

export function getSearchApi(): SearchApi {
  return ApiFactory.authenticated(SearchApi);
}
